
import {
    AdminEntityList,
    AdminEntityItemCreate,
    AdminEntityItemDetail,
    AdminEntityItemEdit,
} from '@/screens'

export default meta => [
    {
        path: 'entities/:entityKey',
        name: 'AdminEntityList',
        component: AdminEntityList,
        meta,
    },
    {
        path: 'entities/:entityKey/create',
        name: 'AdminEntityItemCreate',
        component: AdminEntityItemCreate,
        meta,
    },
    {
        path: 'entities/:entityKey/detail/:id',
        name: 'AdminEntityItemDetail',
        component: AdminEntityItemDetail,
        meta,
    },
    {
        path: 'entities/:entityKey/edit/:id',
        name: 'AdminEntityItemEdit',
        component: AdminEntityItemEdit,
        meta,
    },
]
